import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';

export const ADMIN_ACCOUNT_QUERY_KEY = 'admin/account/<accountId>';

export function useAdminAccountQuery({
	enabled,
	accountId,
	meta,
}: {
	enabled?: boolean;
	accountId: string;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IAccount>(`admin/account/${encodeURIComponent(accountId)}`, 'GET'),
		queryKey: [ADMIN_ACCOUNT_QUERY_KEY, accountId],
		enabled,
		meta,
	});
}
